import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdobeillustratorComponent } from './simple-icons-adobeillustrator.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdobeillustratorComponent ],
    exports:      [ SimpleIconsAdobeillustratorComponent ],
    bootstrap:    []
})
export class SimpleIconsAdobeillustratorModule {}
